import { MAX_VISIBLE_CONTACTS } from 'components/agent_hub_components/constants'
import { useFetchContactsByIdsGQLQuery } from 'features/contacts'

export const useContactPickerWidget = (contactIds) => {
  const requestPayload = {
    input: {
      pagination: { first: MAX_VISIBLE_CONTACTS },
      filterBy: [
        {
          filterField: 'ID',
          operation: 'EQUAL',
          filterValue: contactIds
        }
      ]
    }
  }

  const { data: contactsData, isLoading } = useFetchContactsByIdsGQLQuery(requestPayload, {
    skip: contactIds.length === 0
  })

  const contactsInfo = contactsData?.contacts?.edges?.map((contact) => ({
    id: contact.node.id,
    name: contact.node.fullName,
    email: contact.node.email,
    lastContacted: contact.node.lastInteractionAt
  })) ?? []

  return {
    contactsInfo,
    loading: isLoading
  }
}
